import React from 'react';

import './styles/Footer.css';

class Footer extends React.Component {
  render() {
    return (
      <div className="FooterContainer">
          <div className="copyright">App made by @danguito</div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js